import milesrank from './milesrank';

const RankingMethods = {

  getGeneralRankingPage:  (pageNumber, pageSize, captains, query) => {
      return milesrank.get("/api/rankings/general", {
      params: {
        pageNo: pageNumber,
        pageSize: pageSize,
        query: query === undefined ? "" : query,
        captains: captains === undefined ? "" : !!captains
      }
    });
  },

  getCruiseRankingPage: (pageNumber, pageSize, cruiseId, captains, query) => {
    return milesrank.get("/api/rankings/cruise/" + cruiseId, {
      params: {
        pageNo: pageNumber,
        pageSize: pageSize,
        query: query === undefined ? "" : query,
        captains: captains === undefined ? "" : !!captains
      },
    });
  },

  getYearRankingPage: (pageNumber, pageSize, year, captains, query) => {
    return milesrank.get("/api/rankings/year/" + year, {
      params: {
        pageNo: pageNumber,
        pageSize: pageSize,
        query: query === undefined ? "" : query,
        captains: captains === undefined ? "" : !!captains
      },
    });
  },

  getYachtCrewRankingPage: (pageNumber, pageSize, yachtId, captains, query) => {
    return milesrank.get("/api/rankings/yacht/" + yachtId, {
      params: {
        pageNo: pageNumber,
        pageSize: pageSize,
        query: query === undefined ? "" : query,
        captains: captains === undefined ? "" : !!captains
      },
    });
  },

  getRanks: (personId, captains) => {
    return milesrank.get(`/api/rankings/${personId}/positions`, {
      params: {
        captains: captains === undefined ? "" : !!captains
      }
    });
  },

  getMultiRanks: (personIds, captains) => {
    if (personIds !== undefined && personIds.length > 0)
      return milesrank.get(`/api/rankings/${personIds.join(',')}/positions`, {
        params: {
          captains: captains === undefined ? "" : !!captains
        }
      });
    return Promise.resolve();
  },

  getTopRanks: (count, captains) => {
    return milesrank.get("/api/rankings/general/top/" + count, {
      params: {
        captains: captains === undefined ? "" : !!captains
      }
    });
  },

}

export default RankingMethods;